// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__Hl-ha","footer-max-container":"Footer_footer-max-container__VeIvg"};